/* template */
<template><div class="buyer-list-wrap" v-if="(buyerList.length > 1)"><div :class="(animateUpClass)" class="buyer-swiper"><div v-for="(item, index) in (buyerList)" :key="item._" class="buyer-item"><mpx-image :src="(item.headImg)" class="buy-user"></mpx-image><div class="buy-info">{{item.buyerMsg}}</div></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m66698d0a"}'>
.animate-up
  transition all 1s ease-in-out
  transform translateY(-38rpx)

.buyer-list-wrap
  height 38rpx
  background rgba(8,22,48,0.40)
  border-radius 18rpx
  padding 0 16rpx 0 4rpx
  overflow hidden
  .buyer-swiper
    width 100%
    height 100%
    display flex
    flex-direction column
  .buyer-item
    display flex
    align-items center
    height 100%
    overflow hidden
    flex none
  .buy-user
    width 31rpx
    height 31rpx
    border-radius 50%
  .buy-info
    margin-left 5rpx
    font-family PingFangSC-Regular
    font-size 20rpx
    color #FFFFFF
    font-weight 400
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
createComponent({
  properties: {
    buyerList: {
      type: Array,
      vulue: () => [],
    },
  },
  attached() {
    if (this.buyerList.length === 1) this.buyerList.push(this.buyerList[0])
    this.scrollAnimate()
  },
  data: {
    animateUp: true,
    timerTimeOut: null,
    innerTimeOut: null,
    speed: 2000,
  },
  computed: {
    animateUpClass() {
      return this.animateUp ? 'animate-up' : ''
    },
  },
  methods: {
    scrollAnimate() {
      this.animateUp = true
      this.timerTimeOut = setTimeout(() => {
        this.buyerList.push(this.buyerList.shift())
        this.animateUp = false
        this.innerTimeOut = setTimeout(() => {
          this.scrollAnimate()
        }, this.speed - 1000)
      }, this.speed)
    },
  },
  detached() {
    this.timerTimeOut && clearTimeout(this.timerTimeOut)
    this.innerTimeOut && clearTimeout(this.innerTimeOut)
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "buyer-list66698d0a",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
